import * as actionTypes from "../../constants/ActionTypes/HardwareInclusive/HardwareInclusive";

const initialState = {
    data: {},
    loading: false,
    success: false,
    error: null
};

const HardwareInclusiveCounter_FETCH = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_INIT:
            return {
                ...state,
                loading: true,
                success: false,
                error:"",
            };

        case actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_SUCCESS:
            return {
                ...state,
                data: action.data,
                loading: false,
                error: null,
                success: true
            };

        case actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false,
                data: {}
            };

        case actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_RESET:
            return initialState;

        default:
            return { ...state };
    }
};

export default HardwareInclusiveCounter_FETCH;
